import { render, staticRenderFns } from "./DataAuthDetail.vue?vue&type=template&id=3fba58d3&scoped=true&"
import script from "./DataAuthDetail.vue?vue&type=script&lang=js&"
export * from "./DataAuthDetail.vue?vue&type=script&lang=js&"
import style0 from "./DataAuthDetail.vue?vue&type=style&index=0&id=3fba58d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fba58d3",
  null
  
)

export default component.exports